<form [formGroup]="omschrijvingBedragFg">
    <snelstart-ui-text-form-control formControlName="omschrijving"
                                    id="omschrijving"
                                    label="Omschrijving"
                                    class="me-1 custom-input-250"
                                    (change)="saveForm()"
    >
    </snelstart-ui-text-form-control>
    <snelstart-ui-number-form-control formControlName="bedrag"
                                      id="bedrag"
                                      label="Bedrag"
                                      [showAllDecimals]="false"
                                      align="right"
                                      [minValue]="1"
                                      prefix="€"
                                      class="me-1 custom-input-250"
                                      (change)="saveForm()"
    >
    </snelstart-ui-number-form-control>
</form>
